import { useTranslation } from 'next-i18next';
import { observer } from 'mobx-react-lite';
import { CategoriesFilters, CategoriesListing, ICategory, TCategoriesTree } from '@features/categories';
import styles from '@features/simple/sections/ProductsListing/ProductsListing.styles';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import { IInfoCardWithMedia } from '@components/typescript';
import FiltersStore from '@features/categories/mobx/stores/FiltersStore';
import CategoriesChildren from '@features/categories/components/CategoriesChildren/CategoriesChildren';
import { TCmsBlocks } from '@features/cms/typescript';
import RenderCmsBlock from '@features/cms/components/RenderCmsBlock';
type PropsType = {
  categoryId: number;
  categoryName: string;
  categoryChildren: Record<symbol, ICategory>;
  infoCards?: IInfoCardWithMedia[];
  isCategoryPage?: boolean;
  filtersStore: FiltersStore;
  categoriesTree?: TCategoriesTree;
  hasProducts?: boolean;
  blocks?: Record<string, TCmsBlocks> | null;
};
const ProductsListing = ({
  categoryId,
  categoryName,
  categoryChildren,
  filtersStore,
  infoCards = [],
  isCategoryPage = false,
  categoriesTree = {},
  hasProducts = false,
  blocks
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const headPosition = isCategoryPage ? 'left' : 'center';
  const headingTitle = isCategoryPage ? <>
      {t('products.plural')}
      <br />
      {categoryName}
    </> : t('choose_furniture_for_configuration');
  return <>
      {hasProducts && <div sx={styles.header(isCategoryPage)} id="products-listing" data-cy="productListingTitle">
          <Heading headingType={2} mobile align={headPosition} color={theme.rawColors.darkGrey700}>
            {headingTitle}
          </Heading>
        </div>}
      {hasProducts && isCategoryPage && Object.values(categoriesTree).length > 0 && categoryChildren && <CategoriesChildren categoryChildren={categoryChildren} />}
      {hasProducts && <>
          <CategoriesFilters filtersStore={filtersStore} />
          <CategoriesListing categoryId={categoryId} categoryName={categoryName} filtersStore={filtersStore} infoCards={infoCards} />
        </>}
      {blocks?.blocks && <div>
          {Object.keys(blocks.blocks).map(key => <RenderCmsBlock key={key} block={blocks.blocks[key]} />)}
        </div>}
    </>;
};
export default observer(ProductsListing);